import Button from '@berlitz/button'
import styled from 'styled-components'

export const Wrapper = styled.div`
  div[class^='Modalstyle__ModalContent'] {
    padding: 0;
  }

  label {
    display: flex;
    gap: 24px;
    cursor: pointer;
    align-items: center;
  }
`

export const UpperContent = styled.div`
  padding: 27px 70px 32px 70px;

  @media (max-width: 500px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`

export const Title = styled.div`
  ${({ theme }) => `
    font-size: ${theme.fontSize.xl};
    font-weight: ${theme.fontWeight.bold};
    line-height: 1.19;
    letter-spacing: 1.12px;
  `}
`

export const Instruction = styled.div`
  ${({ theme }) => `
    font-size: ${theme.fontSize.sm};
    font-weight: ${theme.fontWeight.bold};
    line-height: 1.22;
    letter-spacing: 0.63px;
  `}
`

export const Option = styled.input`
  margin: 0;
  ${({ theme }) => `
    height: ${theme.fontSize.xs};
    width: ${theme.fontSize.xs};
  `}
`

export const OptionText = styled.span`
  ${({ theme }) => `
    font-size: ${theme.fontSize.xs};
    font-weight: ${theme.fontWeight.regular};
  `}
  line-height: 1.44;
  letter-spacing: 0.56px;
`

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  ${({ theme }) => `
    padding: 0 ${theme.space.sm} ${theme.space.md} ${theme.space.sm};
  `}

  @media (max-width: 430px) {
    flex-direction: column;
    align-items: unset;
  }
`

export const SwitchDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  letter-spacing: 0.49px;

  ${({ theme }) => `
    font-size: ${theme.fontSize.xxs};
    font-weight: ${theme.fontWeight.bold};
  `}
`

export const ConfirmButton = styled(Button)`
  letter-spacing: 0.49px;
  padding: 9px 14px;

  ${({ theme }) => `
    font-size: ${theme.fontSize.xxs};
    font-weight: ${theme.fontWeight.bold};
  `}
`
